import { Spinner } from "reactstrap";
import FormField from "../ui/FormField";
import { Button } from "../Button";
import { X } from "lucide-react";

const AccountInfoClient = ({ formData, setFormData, errors,isLoading, handelUpdate }) => {

    console.log("edit account : ",formData )

    const leadSources = [
        "Advertisement",
        "Website",
        "Referral",
        "Social Media",
        "Trade Show",
        "Others"
    ];

    const industries = [
        "Technology",
        "Finance",
        "Healthcare",
        "Manufacturing",
        "Retail",
        "Others"
    ];

    const companyTypes = [
        "PUBLIC_LIMITED_COMPANY",
        "PRIVATE_LIMITED_COMPANY",
        "PARTNERSHIP_FIRM",
        "SOLE_PROPRIETORSHIP",
        "LIMITED_LIABILITY_PARTNERSHIP"
    ];

    const companyTypeOptions = companyTypes.map(type => ({
        value: type,
        label: type
            .split("_")
            .map(word => word.charAt(0) + word.slice(1).toLowerCase())
            .join(" ")
    }));

    const onChange = (name, value) => {
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    return (
        <div onClick={(e)=> e.stopPropagation()} className="bg-white w-4/5 md:w-3/5 p-2 rounded-lg z-50 max-h-[90vh] overflow-auto">
            <div className="flex flex-row items-center justify-between border-b border-b-gray-200 pb-2">
                <div className="text-lg font-semibold text-gray-900">Account Information</div>
                <button
                    type="button"
                    onClick={() => setFormData(null)} 
                    className="bg-red-50 p-1rounded-md text-sm font-medium text-red-700 hover:bg-red-100"
                >
                    <X/>
                </button>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
                <FormField
                    label="Account Owner"
                    value={formData.accountOwner || ""}
                    onChange={(value) => onChange("accountOwner", value)}
                    required={true}
                    placeholder="Enter account Owner"
                    error={errors.accountOwner}
                />

                <FormField
                    label="Account Name"
                    value={formData.accountName || ""}
                    onChange={(value) => onChange("accountName", value)}
                    required={true}
                    placeholder="Enter account name"
                    error={errors.accountName}
                />

                {/* <FormField
                    label="Title"
                    value={formData.title || ""}
                    onChange={(value) => onChange("title", value)}
                    placeholder="Enter title"
                /> */}

                <FormField
                    label="Email"
                    type="email"
                    value={formData.email || ""}
                    onChange={(value) => onChange("email", value)}
                    required={true}
                    placeholder="Enter email address"
                    error={errors.email}
                />

                <FormField
                    label="Fax"
                    type="text"
                    value={formData.fax || ""}
                    onChange={(value) => {
                        const digitsOnly = value.replace(/\D/g, "").slice(0, 18);
                        onChange("fax", digitsOnly);
                    }}
                    placeholder="Enter fax number"
                    required
                    maxLength={10}
                    minLength={10}
                    error={errors.fax}
                />
                <FormField
                    label="Mobile Number"
                    type="text"
                    value={formData.mobileNumber || ""}
                    onChange={(value) => {
                        const digitsOnly = value.replace(/\D/g, "").slice(0, 10);
                        onChange("mobileNumber", digitsOnly);
                    }}
                    placeholder="Enter mobileNumber number"
                    // required
                    maxLength={10}
                    minLength={10}
                    error={errors.mobileNumber}
                />
                <FormField
                    label="Phone Number"
                    type="text"
                    value={formData.phoneNumber || ""}
                    onChange={(value) => {
                        const digitsOnly = value.replace(/\D/g, "").slice(0, 10);
                        onChange("phoneNumber", digitsOnly);
                    }}
                    placeholder="Enter phoneNumber number"
                    // required
                    maxLength={10}
                    minLength={10}
                    error={errors.phoneNumber}
                />


                <FormField
                    label="Website"
                    value={formData.website || ""}
                    onChange={(value) => onChange("website", value)}
                    required
                    error={errors.website}
                    placeholder="Enter website URL"
                />

                <FormField
                    label="Lead Source"
                    type="dropdown"
                    value={formData.leadSource || ""}
                    onChange={(value) => onChange("leadSource", value)}
                    options={[...leadSources]}
                />

                <FormField
                    label="Industry"
                    type="dropdown"
                    searchable
                    value={formData.industry || ""}
                    onChange={(value) => onChange("industry", value)}
                    required
                    options={industries}
                    error={errors.industry}
                />

                <FormField
                    label="PAN Number"
                    type="pancard"
                    value={formData.panNumber || ""}
                    onChange={(value) => onChange("panNumber", value)}
                    placeholder="ABCDE1234F"
                    required
                    error={errors.panNumber}
                    maxLength={10}
                />

                <FormField
                    label="Company Type"
                    type="dropdown"
                    value={formData.companyType || ""}
                    onChange={(value) => onChange("companyType", value)}
                    required={true}
                    options={[{ value: "", label: "Select Company Type" }, ...companyTypeOptions]}
                    error={errors.companyType}
                />
            </div>
            <div className='flex flex-row items-center justify-end gap-2'>
                <button
                    type="button"
                    onClick={() => setFormData(null)} 
                    className="bg-red-50 py-2 px-4 border border-red-300 rounded-md text-sm font-medium text-red-700 hover:bg-red-100"
                >
                    Cancel
                </button>
                {isLoading ? 
                <Button label={<Spinner size={"sm"}/>}/> :
                <Button label="Update" type="button" onClick={(e)=> handelUpdate(e)} className="m-2"/>
                }
            </div>
        </div>
    );
};

export default AccountInfoClient;